import { render, staticRenderFns } from "./modal-with-sidebar.vue?vue&type=template&id=ef8d1c54&"
import script from "./modal-with-sidebar.vue?vue&type=script&lang=ts&"
export * from "./modal-with-sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports